export const parseRolesString = (rolesStr: string): string[] => {
  if (!rolesStr) return [];

  try {
    const parsed = JSON.parse(rolesStr);

    if (Array.isArray(parsed)) {
      return parsed
        .map((role) => String(role).trim())
        .filter(Boolean);
    }
  } catch {
    // fall through to legacy formats
  }

  return rolesStr
    .replace(/^\[|\]$/g, '')
    .split(',')
    .map((role) => role.trim().replace(/^['"]|['"]$/g, ''))
    .filter(Boolean);
};


export const formatDate = (date: Date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatRequestedAt = (value?: string) => {
  if (!value) return "-";
  const normalized = /z$/i.test(value) ? value : `${value}Z`;
  const parsed = new Date(normalized);
  if (Number.isNaN(parsed.getTime())) return "-";
  return parsed.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Bucharest",
  });
};

// Mirrors the backend's LeaveRequestApprovalService#assertCurrentUserCanApprove
// for the Manager step: ADMIN, or the request's current approver (manager or
// active OoO substitute), or the employee's actual manager. Other roles (e.g.
// HR, which sees every request) never grant approve/reject on their own.
export const canReviewAsManager = (
  request: { approverEmail?: string | null; managerEmail?: string | null },
  currentUserEmail: string | undefined,
  isAdmin: boolean,
) => {
  if (isAdmin) return true;
  const email = currentUserEmail?.trim().toLowerCase();
  if (!email) return false;
  return [request.approverEmail, request.managerEmail].some(
    (candidate) => candidate?.trim().toLowerCase() === email,
  );
};
